export default class FeZone {
    /**
     * @type {string}
     * @memberof FeZone
     * @name 学部Id
     */
    public zoneId: string;
    /**
     * @type {string}
     * @memberof FeZone
     * @name 学部编号
     */
    public no: string;
    /**
     * @type {string}
     * @memberof FeZone
     * @name 学部名字
     */
    public name: string;
    /**
     * @type {string}
     * @memberof FeZone
     * @name 学制年限
     */
    public year: string;
    /**
     * @type {string}
     * @memberof FeZone
     * @name 所属学段
     */
    public section: string;
    /**
     * @type {string}
     * @memberof FeZone
     * @name 排序字段
     */
    public sortSeq: string;
    constructor({
        zoneId = '',
        no = '',
        name = '',
        year = '',
        section = '',
        sortSeq = ''
    } = {}) {
        this.zoneId = zoneId,
        this.no = no,
        this.name = name,
        this.year = year,
        this.section = section,
        this.sortSeq = sortSeq
    }
}